import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconModule } from '../icon/icon.module';

import { SheetContainer } from './sheet-container.component';
import { SheetDirective } from './sheet.directive';
import { SheetService } from './sheet.service';

import { OverlayModule } from '@angular/cdk/overlay';
import { ButtonModule } from '../button/button.module';

export { SheetContainer } from './sheet-container.component';
export { SheetDirective } from './sheet.directive';
export { SheetService } from './sheet.service';
export { SheetRef } from './sheet-ref';

@NgModule({
  declarations: [
    SheetContainer,
    SheetDirective,
  ],
  exports: [
    SheetContainer,
    SheetDirective,
  ],
  imports: [
    CommonModule,
    OverlayModule,
    ButtonModule,
    IconModule,
  ],
  entryComponents: [
    SheetContainer
  ],
  providers: [
    SheetService,
  ],
})
export class SheetModule { }
